import { useEffect, useState } from 'react';
import { animate, useReducedMotion } from 'framer-motion';

const DEFAULT_DURATION_SECONDS = 0.9;
const EASE_OUT: [number, number, number, number] = [0, 0, 0.2, 1];

interface CountUpOptions {
  delayMs?: number;
  durationSeconds?: number;
}

export const useCountUp = (target: number, options: CountUpOptions = {}): number => {
  const { delayMs = 0, durationSeconds = DEFAULT_DURATION_SECONDS } = options;
  const reduceMotion = useReducedMotion();
  const [value, setValue] = useState(reduceMotion ? target : 0);

  useEffect(() => {
    if (reduceMotion) {
      setValue(target);
      return;
    }
    const controls = animate(0, target, {
      duration: durationSeconds,
      delay: delayMs / 1000,
      ease: EASE_OUT,
      onUpdate: setValue,
    });
    return () => controls.stop();
  }, [target, delayMs, durationSeconds, reduceMotion]);

  return value;
};
